///*eslint-disable multiline-ternary */
///*eslint-disable jsx-a11y/anchor-is-valid */
///*eslint-disable array-callback-return */
///*eslint-disable linebreak-style */
///*eslint-disable eqeqeq */
///*eslint-disable no-redeclare */
///*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, Link, Navigate } from 'react-router-dom';
import { Col, Container, Row, OverlayTrigger, Popover } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import ToastMessage from '../../common/ToastMessage';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';
import useDate from '../../../utils/useDate';
import 'mdbreact/dist/css/mdb.css';
import 'mdbreact/dist/css/style.css';
import './detail.scss';
import APIEndpoints from '../../../api/APIEndpoints';
import CustomClientError from '../../../errorhandling/CustomClientError';
import AdditionalPaymentDetails from '../AdditonalPaymentDetails/additionalPaymentDetails';
import ClaimsDocuments from '../ClaimsDocuments/ClaimsDocuments';
//Toast

import { axiosInstance } from '../../../../api/axios';
import Panels from './panels';
import Transaction from './transaction';
import Header from '../../common/Header/Header';
import BackArrow from 'src/Admin/img/arrow_back.svg';
import FilterModal from '../../common/filter-modal/FilterModal';
import GridColumnOptions from './gridcolumnsoptions';
import MasterPermissions from 'src/Admin/api/MasterPermissions';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

const ClaimDetails = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [serviceDuration, setServiceDuration] = useState({});
  const [description, setDiscription] = useState();
  const [descriptionAdjustment, setDescriptionAdjustment] = useState();
  const [otherDiagnosisCode, setOtherDiagnosisCode] = useState();
  const { formatDate } = useDate();

  const ServiceDuration = (serviceLine) => {
    const datesArray = [];
    serviceLine &&
      serviceLine.map((data) => {
        datesArray.push(new Date(data.FromDate));
        datesArray.push(new Date(data.ThroughDate));
        return;
      });
    let startDate = new Date(Math.min(...datesArray));
    let endDate = new Date(Math.max(...datesArray));
    startDate = JSON.stringify(startDate);
    startDate = startDate.slice(1, 11);
    endDate = JSON.stringify(endDate);
    endDate = endDate.slice(1, 11);
    setServiceDuration({
      FromDate: formatDate(startDate),
      ThroughDate: formatDate(endDate),
    });
  };

  const getAdjustmentClaimDescription = async () => {
    try {
      const descriptionToolTipAdjustment = await axiosInstance.get(
        APIEndpoints.getClaimAttributeDescriptionAdjustment(),
      );
      setDescriptionAdjustment(
        descriptionToolTipAdjustment?.data?.Response?.EnabledCode,
      );
    } catch (error) {
      console.log(error);
    }
  };

  const getDescriptionToolTip = async (codeType, code) => {
    try {
      if (codeType === 'CPG CODE') {
        setDiscription(claimDetailsResp?.Claim?.CPGCodeDescription);
      } else if (codeType === 'Adjustment Reasons') {
        const codeAdjust =
          descriptionAdjustment &&
          descriptionAdjustment.filter((codes) => codes?.Code === code);
        setDiscription(codeAdjust[0].Description);
        console.log(
          codeAdjust[0].Description,
          descriptionAdjustment,
          'descriptionToolTipAdjustment',
        );
      } else {
        const descriptionToolTip = await axiosInstance.get(
          APIEndpoints.getClaimAttributeDescription() +
            'codeType/' +
            codeType +
            '/code/' +
            code,
        );
        setDiscription(descriptionToolTip.data.Response.CodeDescription);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const overlay = (label, codeType) => {
    return (
      <OverlayTrigger
        placement="top"
        delay={{ show: 200, hide: 450 }}
        overlay={
          description ? (
            <Popover>
              <Popover.Content className="claims-tooltip">
                {description && (
                  <span>
                    {label} - {description}
                  </span>
                )}
              </Popover.Content>
            </Popover>
          ) : (
            <div></div>
          )
        }
      >
        <div
          onMouseEnter={() => {
            getDescriptionToolTip(codeType, label);
          }}
          onMouseLeave={() => {
            setDiscription('');
          }}
        >
          {label}
        </div>
      </OverlayTrigger>
    );
  };
  const fetchClaimLabelSummary = async () => {
    const resourceData = await axiosInstance.get(
      `${APIEndpoints.getAllClaimLabelsLIst()}`,
    );
    const resourceList = resourceData?.data?.Response?.ClaimStatusLabels;
    setClaimsLabelConfiguration(resourceList);
  };

  const loggedInUserType = useSelector(({ user }) => user.userData?.UserType);
  //get claim external status key
  const getClaimStatusLabelKey = () => {
    //loggedInUserType
    return `ExternalStatus${loggedInUserType}`;
  };

  //eachRecord.ExternalStatusMemberDependent.toLowerCase() === jmpStatus.toLowerCase(),
  const getJVCoreStatusFromConfig = (jmpStatus, claimLabels) => {
    if (claimLabels?.length > 0) {
      const matchingUniqueRecord = claimLabels.filter(
        (eachRecord) =>
          eachRecord[getClaimStatusLabelKey()]?.toLowerCase() ===
          jmpStatus?.toLowerCase(),
      );
      if (
        matchingUniqueRecord[0]?.InternalStatus === 'PAID' ||
        matchingUniqueRecord[0]?.InternalStatus === 'Denied'
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  const [claimsLabelConfiguration, setClaimsLabelConfiguration] = useState();
  //Fetching Claim Details data
  const fetchClaimDetails = async (claimOID) => {
    const currentDate = new Date().toISOString().split('T')[0];
    try {
      const responseClaimDetails = await axiosInstance.get(
        APIEndpoints.getClaimDetailsResource() + claimOID,
      );
      const configNetworkName =
        Coverage_Network?.length > 0
          ? Coverage_Network.filter(
              (network) =>
                network.NetworkName ===
                responseClaimDetails?.data?.Response?.Claim?.NetworkNameAndCode,
            )
          : [];
      if (configNetworkName.length != 0) {
        SetnetworkName(configNetworkName[0].Portal_Display_Label);
      } else {
        SetnetworkName(
          responseClaimDetails?.data?.Response?.Claim?.NetworkNameAndCode,
        );
      }
      ServiceDuration(responseClaimDetails?.data?.Response.Claim.ServiceLine);
      setClaimDetailsResp(responseClaimDetails?.data?.Response);
      //if (responseClaimDetails?.data?.Response?.SuppressPaymentInfo) {
      if (
        responseClaimDetails?.data?.Response?.Claim?.DisplayPaymentInfo ===
        'true'
      ) {
        setGridColumnsDisplay(ServiceLineSettings);
      } else {
        const columnsData = {
          Service_Date: ServiceLineSettings.Service_Date,
          Service_Code: ServiceLineSettings.Service_Code,
          Charge: ServiceLineSettings.Charge,
        };
        setGridColumnsDisplay(columnsData);
      }
      const otherDiagnosis = responseClaimDetails?.data?.Response.Claim;
      const filterObjectDia = Object.fromEntries(
        Object.entries(otherDiagnosis).filter(
          ([key, value]) => key.includes('DiagnosisICD') && value !== '',
        ),
      );
      const otherDiaArray = Object.keys(filterObjectDia).map((key) => ({
        key,
        value: filterObjectDia[key],
      }));
      setOtherDiagnosisCode(otherDiaArray);

      setDataFetching(false);
    } catch (error) {
      console.log(error);
      SetnetworkName('');
      setDataFetching(false);
      setIsAPIFailed(true);
    }
  };

  const [claimDetailsResp, setClaimDetailsResp] = useState();

  //These are for data fetching and if API Fails
  const [dataFetching, setDataFetching] = useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [isClaimID, SetIsClaimID] = useState(true);
  const [isSourceAccount, SetIsSourceAccount] = useState();
  const [networkName, SetnetworkName] = useState(' ');
  const { Coverage_Network } = useSelector((state) => state.app?.customNetwork);
  const { appConfigs } = useSelector((state) => state.app) || {};
  const ServiceLineSettings = { ...appConfigs.ServiceLineSettings };
  const { userData } = useSelector((state) => state.user);
  const [displayColumnsCount, setDisplayColumnsCount] = useState(0);

  const [gridColumnsDisplay, setGridColumnsDisplay] = useState({});
  const [isOpenColumnsPopup, setIsOpenColumnsPopup] = useState(false);

  const applyOptions = () => {
    setIsOpenColumnsPopup(false);
  };

  const showOptions = () => {
    setIsOpenColumnsPopup(true);
  };

  useEffect(() => {
    const columns = Object.keys(ServiceLineSettings);
    const showColumns = columns.filter((key) => {
      return ServiceLineSettings[key];
    });
    setDisplayColumnsCount(showColumns?.length || 0);
  }, []);

  /*const fetchClaimListsDocuments = async (claimNumberValue) => {
    try {
      const responseClaimAllDocuments = await axiosInstance.get(
        'https://a1m-test.mphasishealthportal.com/apigw/v1/documentdetails/getlistdocuments/entityType/claims/entityKey/' +
          claimNumberValue,
      );
      console.log('responseClaimAllDocuments', responseClaimAllDocuments);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchClaimListsDocuments(claimDetailsResp?.Claim?.Claimnumber);
  }, [claimDetailsResp?.Claim?.Claimnumber]);*/

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const CID = new URLSearchParams(location.search).get('CID');
    const source = new URLSearchParams(location.search).get('source');
    if (source === 'account') {
      SetIsSourceAccount(true);
    } else {
      SetIsSourceAccount(false);
    }
    if (CID !== null) {
      setDataFetching(true);
      SetIsClaimID(true);
      fetchClaimDetails(CID);
      fetchClaimLabelSummary();
    } else {
      SetIsClaimID(false);
    }
  }, [location.search]);

  const OptionChangeHandler = (optionText) => {
    let totalCount = displayColumnsCount;
    if (!gridColumnsDisplay[optionText]) {
      totalCount = totalCount + 1;
    } else {
      totalCount = totalCount - 1;
    }
    const updatedOptions = {
      ...gridColumnsDisplay,
      [optionText]: !gridColumnsDisplay[optionText],
    };
    if (totalCount <= 8) {
      console.log(displayColumnsCount);
      setDisplayColumnsCount(totalCount);
      setGridColumnsDisplay(updatedOptions);
    } else {
      toast.warning(
        <ToastMessage
          type="warning"
          subTitle={'You can select a maximum of 8 columns'}
        />,
      );
    }
  };

  const permissionForAdditionalPayment = MasterPermissions.CheckPermission(
    'View Additional Payment Details',
  );
  const permissionForDownloadClaimsDocument = MasterPermissions.CheckPermission(
    'Download Claims Document',
  );

  useEffect(() => {
    if (claimDetailsResp?.Claim?.AdjustmentReasonCode) {
      getAdjustmentClaimDescription();
    }
  }, [claimDetailsResp]);
  return (
    <Container className="claims-detail-container">
      <div>
        {(!isClaimID && claimDetailsResp) || isAPIFailed ? (
          <CustomClientError
            ErrorHeading="Something went wrong with request!"
            ErrorMessage="Please try again."
          />
        ) : (
          <div className="dashboard-navbar">
            <div>
              <Row className="container-title d-md-block d-lg-block d-flex align-items-center">
                <Col className=" d-flex align-items-center">
                  {isSourceAccount ? (
                    <>
                      {/*<Link
                        to="/admin/search-claims-results"
                        state={location.state}
                        className="redirect-arrow p-0"
                      >
                        <img src={BackArrow} alt="logo" />
                      </Link> */}
                      <Link
                        to="/admin/search-claims-results"
                        state={location.state.preserveData}
                        className="redirect-arrow p-0"
                      >
                        <img src={BackArrow} alt="logo" />
                      </Link>
                      <h1 className="content-header mt-3">
                        Claim Number{' '}
                        <span className="content-header-bold">
                          {' '}
                          {claimDetailsResp?.Claim?.Claimnumber}
                        </span>
                      </h1>
                    </>
                  ) : (
                    <>
                      <Link
                        to="/admin/search-claims-results"
                        state={location.state.preserveData}
                        className="redirect-arrow p-0"
                      >
                        <img src={BackArrow} alt="logo" />
                      </Link>
                      <h1 className="content-header mt-3">
                        Claim Number{' '}
                        <span className="content-header-bold">
                          {' '}
                          {claimDetailsResp?.Claim?.Claimnumber}
                        </span>
                      </h1>
                    </>
                  )}
                </Col>
                {/*<Col>
                  { isSourceAccount ?
                    <Header linkTo={ '/admin/view-member' }
                      header={ `Claim Number ${claimDetailsResp?.Claim?.Claimnumber}`
                      }
                      search={ '?source=acsummary'}
                    />
                    :
                    <Header linkTo={ '/admin/view-member' }
                      header={ `Claim Number ${claimDetailsResp?.Claim?.Claimnumber}`}
                      search={'?source=claims'}
                    /> }
                </Col> */}
              </Row>

              {/*<Row className="mx-0">
                <h1 className="content-header mt-3">
                  Claim <span className="content-header-bold"> {claimDetailsResp?.Claim?.Claimnumber}</span>
                </h1>
              </Row> */}

              <div className="top-info">
                {claimDetailsResp?.Claim?.RelatedClaims &&
                  claimDetailsResp?.Claim?.RelatedClaims?.length > 0 && (
                    <Row className="page-info-line">
                      <Col className="pl-0">
                        <ul>
                          <li>
                            <span className="page-info-title">
                              Related Claims:&nbsp;&nbsp;
                            </span>
                            {claimDetailsResp?.Claim?.RelatedClaims.map(
                              (relatedClaim, index) => {
                                return (
                                  <Link
                                    key={relatedClaim.OID}
                                    className="claim-variation-link"
                                    to={`/admin/search-claim-details?CID=${relatedClaim.OID}&source=claims`}
                                    state={{
                                      OID: location.state.OID,
                                      memberType: location.state.memberType,
                                      preserveData: location.state.preserveData,
                                    }}
                                  >
                                    {relatedClaim.Claimnumber}
                                    {index <
                                    claimDetailsResp?.Claim?.RelatedClaims
                                      ?.length -
                                      1
                                      ? `, `
                                      : ''}
                                  </Link>
                                );
                              },
                            )}
                          </li>
                        </ul>
                      </Col>
                    </Row>
                  )}
              </div>

              <div className="top-info top-info-2">
                <Row className="page-info-line">
                  <Col className="pl-0">
                    {!dataFetching && (
                      <ul>
                        <li>
                          <span className="page-info-title">
                            Claim Type:&nbsp;&nbsp;
                          </span>
                          <span className="page-info-content">
                            {claimDetailsResp?.Claim?.Product}{' '}
                            <span className="pipe">
                              &nbsp;&nbsp;|&nbsp;&nbsp;
                            </span>
                          </span>
                        </li>
                        <li>
                          <span className="page-info-title">
                            Service Date Duration:&nbsp;&nbsp;
                          </span>
                          {serviceDuration !== 'Invalid date' &&
                            serviceDuration.ThroughDate !== 'Invalid date' && (
                              <span className="page-info-content">
                                {/*{claimDetailsResp?.Claim?.ServiceDate === ''
                              ? 'NA'
                              : formatDate(
                                  claimDetailsResp?.Claim?.ServiceDate,
                                )} */}
                                {serviceDuration.FromDate}&nbsp;-&nbsp;
                                {serviceDuration.ThroughDate}
                              </span>
                            )}
                        </li>
                        {claimDetailsResp?.Claim?.DateReceived && (
                          <li>
                            <span className="page-info-content">
                              &nbsp;&nbsp;|&nbsp;&nbsp;{' '}
                            </span>
                            <span className="page-info-title">
                              Received on:&nbsp;&nbsp;
                            </span>
                            <span className="page-info-content">
                              {claimDetailsResp?.Claim?.DateReceived === ''
                                ? 'NA'
                                : formatDate(
                                    claimDetailsResp?.Claim?.DateReceived,
                                  )}{' '}
                              &nbsp;&nbsp;{' '}
                            </span>
                          </li>
                        )}
                        {getJVCoreStatusFromConfig(
                          claimDetailsResp?.Claim?.ClaimStatus,
                          claimsLabelConfiguration,
                        )
                          ? claimDetailsResp?.Claim?.ProcessedDate && (
                              <li>
                                <span className="pipe">
                                  &nbsp;&nbsp;|&nbsp;&nbsp;{' '}
                                </span>
                                <span className="page-info-title">
                                  Processed on:&nbsp;&nbsp;
                                </span>
                                <span className="page-info-content">
                                  {!Object.prototype.hasOwnProperty.call(
                                    claimDetailsResp?.Claim,
                                    'ProcessedDate',
                                  )
                                    ? 'NA'
                                    : formatDate(
                                        claimDetailsResp?.Claim?.ProcessedDate,
                                      )}{' '}
                                  &nbsp;&nbsp;{' '}
                                </span>
                              </li>
                            )
                          : claimDetailsResp?.Claim?.ProcessedDate &&
                            claimDetailsResp?.Claim?.ClaimStatus !==
                              'Processing' && (
                              <li>
                                <span className="page-info-content">
                                  &nbsp;&nbsp;|&nbsp;&nbsp;{' '}
                                </span>
                                <span className="page-info-title">
                                  Processed on:&nbsp;&nbsp;
                                </span>
                                <span className="page-info-content">
                                  {claimDetailsResp?.Claim?.ProcessedDate
                                    ? formatDate(
                                        claimDetailsResp?.Claim?.ProcessedDate,
                                      )
                                    : 'NA'}{' '}
                                  &nbsp;&nbsp;{' '}
                                </span>
                              </li>
                            )}
                        {/*{!dataFetching  && <li>
                        <span className="page-info-title">Processed on:&nbsp;&nbsp;</span>
                        <span className="page-info-content">
                          {claimDetailsResp?.Claim?.ProcessedDate ?  moment( claimDetailsResp?.Claim?.ProcessedDate ).format( 'DD-MMM-YYYY' ) :'NA'} &nbsp;&nbsp;{' '}
                        </span>
                      </li>} */}
                      </ul>
                    )}
                  </Col>
                </Row>
              </div>

              <Panels
                claimDetailsResp={claimDetailsResp}
                dataFetching={dataFetching}
                networkName={networkName}
                getJVCoreStatusFromConfig={getJVCoreStatusFromConfig}
                claimsLabelConfiguration={claimsLabelConfiguration}
                overlay={overlay}
                otherDiagnosisCode={otherDiagnosisCode}
                oid={location.state.OID}
                memberType={location.state.memberType}
              />
              {!dataFetching && (
                <Row>
                  <Col>
                    <p
                      className="position-absolute show-hide-options provider-name"
                      onClick={showOptions}
                    >
                      Show / Hide Column
                    </p>
                  </Col>
                </Row>
              )}

              <Transaction
                claimDetailsResp={claimDetailsResp}
                dataFetching={dataFetching}
                gridColumnsDisplay={gridColumnsDisplay}
                overlay={overlay}
              />
              {!dataFetching && (
                <div className="pool-payment ">
                  <div className="pool-payment-box">
                    <div className="pool-right">
                      <div className="pool-first">
                        <span>Patient Responsibility</span>
                        <span>
                          {/*{claimDetailsResp?.Claim?.DisplayPaymentInfo === 'true' */}
                          {claimDetailsResp?.Claim?.DisplayPaymentInfo ===
                          'true'
                            ? formatter.format(
                                claimDetailsResp?.Claim?.PatientResponsibility,
                              )
                            : '---'}
                        </span>
                      </div>
                      <div className="pool-first">
                        <span>Pool Payment Amount</span>
                        <span>
                          {claimDetailsResp?.Claim?.Poolpayment
                            ? formatter.format(
                                claimDetailsResp?.Claim?.Poolpayment,
                              )
                            : '---'}
                        </span>
                      </div>
                    </div>
                    <span className="vertical-pool-divider"></span>
                    <div className="pool-right">
                      <div className="pool-first">
                        <span>Adjustment Made to Claim Payment</span>
                        <span>
                          {claimDetailsResp?.Claim
                            ?.Adjustment_Made_Claim_Payment
                            ? formatter.format(
                                claimDetailsResp?.Claim
                                  ?.Adjustment_Made_Claim_Payment,
                              )
                            : '---'}
                        </span>
                      </div>
                      <div className="pool-first">
                        <span>Surcharge</span>
                        <span>
                          {claimDetailsResp?.Claim?.Surcharges
                            ? formatter.format(
                                claimDetailsResp?.Claim?.Surcharges,
                              )
                            : '---'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {permissionForAdditionalPayment && (
                <AdditionalPaymentDetails
                  additioanlData={claimDetailsResp?.Claim}
                  dataFetching={dataFetching}
                />
              )}

              {/*This JMP-5091 story is pushed to backlog. Once the story is ready we will work oon this.
                <ClaimsDocuments dataFetching={dataFetching} />
                */}
              {permissionForDownloadClaimsDocument && (
                <ClaimsDocuments
                  getClaimNumber={claimDetailsResp?.Claim?.Claimnumber}
                />
              )}
            </div>
          </div>
        )}
      </div>
      <FilterModal
        titleLabel="Show/Hide Columns"
        isVisible={isOpenColumnsPopup}
        onHide={() => {
          setIsOpenColumnsPopup(false);
        }}
        showApply={false}
        showCancelLabel="Close"
        customClasses="show-hide-filter-options"
      >
        <Container className="show-hide-options-names">
          {Object.prototype.hasOwnProperty.call(
            gridColumnsDisplay,
            'Service_Date',
          ) && (
            <div className="mt-2 ml-3">
              <GridColumnOptions
                Optionlabel="Service Date"
                optionText="Service_Date"
                optionChangeHandler={OptionChangeHandler}
                gridColumnsDisplay={gridColumnsDisplay}
              />
            </div>
          )}
          {Object.prototype.hasOwnProperty.call(
            gridColumnsDisplay,
            'Service_Qualifier',
          ) &&
            //claimDetailsResp?.Claim?.SuppressPaymentInfo === 'false' && (
            claimDetailsResp?.Claim?.DisplayPaymentInfo === 'true' && (
              <div className="mt-2 ml-3">
                <GridColumnOptions
                  Optionlabel="Service Qualifier"
                  optionText="Service_Qualifier"
                  optionChangeHandler={OptionChangeHandler}
                  gridColumnsDisplay={gridColumnsDisplay}
                />
              </div>
            )}
          {Object.prototype.hasOwnProperty.call(
            gridColumnsDisplay,
            'Service_Code',
          ) && (
            <div className="mt-2 ml-3">
              <GridColumnOptions
                Optionlabel="Service Code"
                optionText="Service_Code"
                optionChangeHandler={OptionChangeHandler}
                gridColumnsDisplay={gridColumnsDisplay}
              />
            </div>
          )}
          {Object.prototype.hasOwnProperty.call(
            gridColumnsDisplay,
            'Modifier',
          ) &&
            //claimDetailsResp?.Claim?.SuppressPaymentInfo === 'false' && (
            claimDetailsResp?.Claim?.DisplayPaymentInfo === 'true' && (
              <div className="mt-2 ml-3">
                <GridColumnOptions
                  Optionlabel="Modifier"
                  optionText="Modifier"
                  optionChangeHandler={OptionChangeHandler}
                  gridColumnsDisplay={gridColumnsDisplay}
                />
              </div>
            )}
          {Object.prototype.hasOwnProperty.call(
            gridColumnsDisplay,
            'Benefit_Code',
          ) &&
            //claimDetailsResp?.Claim?.SuppressPaymentInfo === 'false' && (
            claimDetailsResp?.Claim?.DisplayPaymentInfo === 'true' && (
              <div className="mt-2 ml-3">
                <GridColumnOptions
                  Optionlabel="Benefit Code"
                  optionText="Benefit_Code"
                  optionChangeHandler={OptionChangeHandler}
                  gridColumnsDisplay={gridColumnsDisplay}
                />
              </div>
            )}
          {Object.prototype.hasOwnProperty.call(gridColumnsDisplay, 'Unit') &&
            //claimDetailsResp?.Claim?.SuppressPaymentInfo === 'false' && (
            claimDetailsResp?.Claim?.DisplayPaymentInfo === 'true' && (
              <div className="mt-2 ml-3">
                <GridColumnOptions
                  Optionlabel="Unit"
                  optionText="Unit"
                  optionChangeHandler={OptionChangeHandler}
                  gridColumnsDisplay={gridColumnsDisplay}
                />
              </div>
            )}
          {Object.prototype.hasOwnProperty.call(
            gridColumnsDisplay,
            'Charge',
          ) && (
            <div className="mt-2 ml-3">
              <GridColumnOptions
                Optionlabel="Charge"
                optionText="Charge"
                optionChangeHandler={OptionChangeHandler}
                gridColumnsDisplay={gridColumnsDisplay}
              />
            </div>
          )}
          {Object.prototype.hasOwnProperty.call(
            gridColumnsDisplay,
            'Not_Paid',
          ) &&
            //claimDetailsResp?.Claim?.SuppressPaymentInfo === 'false' && (
            claimDetailsResp?.Claim?.DisplayPaymentInfo === 'true' && (
              <div className="mt-2 ml-3">
                <GridColumnOptions
                  Optionlabel="Not Paid"
                  optionText="Not_Paid"
                  optionChangeHandler={OptionChangeHandler}
                  gridColumnsDisplay={gridColumnsDisplay}
                />
              </div>
            )}
          {Object.prototype.hasOwnProperty.call(gridColumnsDisplay, 'Reason') &&
            //claimDetailsResp?.Claim?.SuppressPaymentInfo === 'false' && (
            claimDetailsResp?.Claim?.DisplayPaymentInfo === 'true' && (
              <div className="mt-2 ml-3">
                <GridColumnOptions
                  Optionlabel="Reason"
                  optionText="Reason"
                  optionChangeHandler={OptionChangeHandler}
                  gridColumnsDisplay={gridColumnsDisplay}
                />
              </div>
            )}
          {Object.prototype.hasOwnProperty.call(
            gridColumnsDisplay,
            'Discount',
          ) &&
            //claimDetailsResp?.Claim?.SuppressPaymentInfo === 'false' && (
            claimDetailsResp?.Claim?.DisplayPaymentInfo === 'true' && (
              <div className="mt-2 ml-3">
                <GridColumnOptions
                  Optionlabel="Discount"
                  optionText="Discount"
                  optionChangeHandler={OptionChangeHandler}
                  gridColumnsDisplay={gridColumnsDisplay}
                />
              </div>
            )}
          {Object.prototype.hasOwnProperty.call(
            gridColumnsDisplay,
            'Covered',
          ) &&
            //claimDetailsResp?.Claim?.SuppressPaymentInfo === 'false' && (
            claimDetailsResp?.Claim?.DisplayPaymentInfo === 'true' && (
              <div className="mt-2 ml-3">
                <GridColumnOptions
                  Optionlabel="Covered"
                  optionText="Covered"
                  optionChangeHandler={OptionChangeHandler}
                  gridColumnsDisplay={gridColumnsDisplay}
                />
              </div>
            )}
          {Object.prototype.hasOwnProperty.call(
            gridColumnsDisplay,
            'Deductible',
          ) &&
            //claimDetailsResp?.Claim?.SuppressPaymentInfo === 'false' && (
            claimDetailsResp?.Claim?.DisplayPaymentInfo === 'true' && (
              <div className="mt-2 ml-3">
                <GridColumnOptions
                  Optionlabel="Deductible"
                  optionText="Deductible"
                  optionChangeHandler={OptionChangeHandler}
                  gridColumnsDisplay={gridColumnsDisplay}
                />
              </div>
            )}
          {Object.prototype.hasOwnProperty.call(
            gridColumnsDisplay,
            'CoinsuranceAmount',
          ) &&
            //claimDetailsResp?.Claim?.SuppressPaymentInfo === 'false' && (
            claimDetailsResp?.Claim?.DisplayPaymentInfo === 'true' && (
              <div className="mt-2 ml-3">
                <GridColumnOptions
                  Optionlabel="Coinsurance%"
                  optionText="CoinsurancePercentage"
                  optionChangeHandler={OptionChangeHandler}
                  gridColumnsDisplay={gridColumnsDisplay}
                />
              </div>
            )}
          {Object.prototype.hasOwnProperty.call(
            gridColumnsDisplay,
            'CoinsurancePercentage',
          ) &&
            //claimDetailsResp?.Claim?.SuppressPaymentInfo === 'false' && (
            claimDetailsResp?.Claim?.DisplayPaymentInfo === 'true' && (
              <div className="mt-2 ml-3">
                <GridColumnOptions
                  Optionlabel="Coinsurance$"
                  optionText="CoinsuranceAmount"
                  optionChangeHandler={OptionChangeHandler}
                  gridColumnsDisplay={gridColumnsDisplay}
                />
              </div>
            )}
          {Object.prototype.hasOwnProperty.call(
            gridColumnsDisplay,
            'Payment_Amount',
          ) &&
            //claimDetailsResp?.Claim?.SuppressPaymentInfo === 'false' && (
            claimDetailsResp?.Claim?.DisplayPaymentInfo === 'true' && (
              <div className="mt-2 ml-3">
                <GridColumnOptions
                  Optionlabel="Payment_Amount"
                  optionText="Payment_Amount"
                  optionChangeHandler={OptionChangeHandler}
                  gridColumnsDisplay={gridColumnsDisplay}
                />
              </div>
            )}
        </Container>
      </FilterModal>
      <div className="toastify">
        <ToastContainer
          draggable
          pauseOnHover
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          autoClose={5000}
          position="top-center"
          newestOnTop={false}
          hideProgressBar={false}
          className="toastcontainer"
        />
      </div>
    </Container>
  );
};
export default ClaimDetails;
